import React from "react";
import styles from "./PageFooter.module.scss";
import { addStaticRootToUrl } from "@src/utils/static";
import MaxWidthContainer from "@src/components/containers/MaxWidthContainer";

export default function PageFooter() {
  return (
    <MaxWidthContainer className={styles.root}>
      <footer className={styles.content}>
        <div className={styles.info}>
          <div>
            <h3>About OrderEasy</h3>
            <p>
              Wrangling suppliers shouldn't feel like herding cats. We bring all
              your distributors into one clean, simple platform&mdash;so you can
              stop chasing orders and get back to what actually matter.
            </p>
            <div className="text-sm font-weight-light margin-top-sm">
              <em>OrderEasy is for licensed veterinary professionals</em>
            </div>
          </div>
          <div>
            <h3>Help & Policies</h3>
            <div className="spaced-content-v-xs">
              <a href="/app/support" data-testid="contact-us-link">
                Contact Us
              </a>
              {/* Note: Removed for Beta - terms and conditions, FAQ removed from footer */}
              {/* <a href="/frequently-asked-questions">FAQ</a> */}
              <a href="/privacy-policy" data-testid="privacy-policy-link">
                Privacy Policy
              </a>
              {/* <a href="/terms-of-service">Terms of Service</a> */}
            </div>
          </div>
          <div className="text-right">
            <img
              id="page-footer-promo-image"
              className={styles.adImage}
              src={addStaticRootToUrl("images/footer_ad_placeholder.png")}
              alt="Footer Advertisement"
            />
          </div>
        </div>

        <div className={styles.copyrightAndSocial}>
          <span>&copy;2025 OrderEasy. All rights reserved.</span>

          {/* Note: Commented out for Beta due to missing functionality */}
          {/* <span className="spaced-content-lg text-lg">
            <a href="https://www.linkedin.com/">
              <i className="fa-brands fa-linkedin" />
            </a>
            <a href="https://www.youtube.com/">
              <i className="fa-brands fa-youtube" />
            </a>
            <a href="https://www.facebook.com/">
              <i className="fa-brands fa-facebook" />
            </a>
            <a href="https://www.instagram.com/">
              <i className="fa-brands fa-instagram" />
            </a>
            <i className="fas fa-at" />
          </span> */}
        </div>
      </footer>
    </MaxWidthContainer>
  );
}
